module.exports = __webpack_public_path__ + "img/logo.77f21e5d.png";